// Zenna — header overlay behaviour
// Finds the header directly and drives it with inline styles, so it
// works regardless of the exact class names this theme version uses.
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('header');
  if (!header) return;

  var hero = document.querySelector('[data-zenna-hero]');
  if (!hero) return; // only float the header on pages with a marked hero

  var CREAM = 'rgb(243,237,231)';
  var OYSTER = 'rgb(220,211,198)';
  var INK = 'rgb(37,35,31)';
  var FOREST = 'rgb(47,65,42)';
  var announcementHeight = 36;

  header.style.position = 'fixed';
  header.style.left = '0';
  header.style.right = '0';
  header.style.zIndex = '30';
  header.style.transition = 'background-color 240ms cubic-bezier(.4,0,.2,1), border-color 240ms cubic-bezier(.4,0,.2,1), top 240ms cubic-bezier(.4,0,.2,1), color 240ms cubic-bezier(.4,0,.2,1)';

  function setImportant(el, prop, val) {
    el.style.setProperty(prop, val, 'important');
  }

  function paint(scrolled) {
    header.style.top = scrolled ? '0px' : announcementHeight + 'px';
    setImportant(header, 'background', scrolled ? CREAM : 'transparent');
    setImportant(header, 'background-color', scrolled ? CREAM : 'transparent');
    setImportant(header, 'border-bottom', scrolled ? '1px solid ' + OYSTER : 'none');
    setImportant(header, 'box-shadow', 'none');
    setImportant(header, 'color', scrolled ? INK : CREAM);
    header.querySelectorAll('a, svg, .header__icon, .header__heading-link, .header__heading, span, path, circle, rect').forEach(function (el) {
      setImportant(el, 'color', scrolled ? INK : CREAM);
      setImportant(el, 'stroke', scrolled ? INK : CREAM);
      setImportant(el, 'fill', scrolled ? INK : CREAM);
    });
  }

  paint(window.scrollY > 80);
  window.addEventListener('scroll', function () {
    paint(window.scrollY > 80);
  }, { passive: true });
});
